import { DialogTitle, Button, DialogActions } from "@mui/material";
import { TransactionType } from "../shared/Consts";
import { Transaction } from "../models/Transaction"
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDialog } from "../libs/dialog/DialogProvider";
import { IAddHoldingProps } from "./AddHolding/IAddHolding"
import HoldingName from "./AddHolding/HoldingName"
import TransPrice from "./AddHolding/TransPrice"
import AccountSelect from "../components/AccountSelect";
import ActionSelect from "./AddHolding/ActionSelect";
import Holding from "../models/Holding";
import CheckButton from "../libs/button/CheckButton";
import EvalText from "../components/EvalText";
import GTextField from "../libs/textfield/GTextField";
import useAddHolding from "../hooks/useAddHolding";
import MenuButton from "../libs/button/MenuButton";
import { TMenuOptions } from "../libs/menu/GMenu";
import SwitchTicker from "./SwitchTicker";
import MoveVert from "../libs/icons/MoveVert";

export default function AddHolding(props:IAddHoldingProps){
    const {
        transaction,currentAccount,setCurrentAccount,priceProps,
        ticker,setTicker,price,setPrice,type,
        isSave,isGIC,isTermed,isCash,isBond,
        updateCash,setUpdateCash,
        count,setCount,note,setNote,yld,setYield,date,setDate,maturiy,setMaturity,busy,
        form, onDup, onType, onDelete, onRedeem, onSave, onReinvest, onDividend, tax, setTax
    } = useAddHolding(props)

    const {openDialog} = useDialog()

    let holdingType;
    const _updateCash = <CheckButton key="updateCash" checked={updateCash} onChange={()=>setUpdateCash(!updateCash)} label="Update Cash"/>
    const _date = <DatePicker key="date" label="Date" value={date} onChange={(e:any)=>setDate(e)}/>
    const _qty = <EvalText key="qty" controlName="qty" form={form} placeholder="Quantity" value={count} onEval={(val)=>setCount(val)} onChange={(e)=>setCount(e.target.value)}/>
    const _price = <TransPrice key="price" controlName="price" form={form} {...props} {...priceProps} type={type}/>
    const _yield = isTermed || isSave ? <EvalText key="yield" placeholder="Yield" value={yld} onEval={(val)=>setYield(val)} onChange={(e)=>setYield(e.target.value)}/> : <></>
    const _maturity = isTermed ?  <DatePicker key="maturity" label="Maturity" value={maturiy} onChange={(e:any)=>setMaturity(e)}/> : <></>
    const inputs = [
        <HoldingName {...props} controlName="ticker" form={form} ticker={ticker} setTicker={setTicker} price={price} setPrice={setPrice} key="name"/>,
        <AccountSelect {...props} showAll={false} onSelect={setCurrentAccount} current={currentAccount} key="account"/>,
        <ActionSelect current={type} onChange={onType} key="type"/>
    ]
    const onSwitch = () => openDialog({id:"switch",children:<SwitchTicker transaction={transaction!}/>})
    
    if (isBond) {
        holdingType = ticker || "New Bond"
        inputs.push(_price, _qty, _date, _maturity, _yield, _updateCash)
    }
    else if (isGIC) {
        holdingType = ticker || "New GIC"
        inputs.push(_qty, _date, _maturity, _yield, _updateCash)
    }
    else if (isCash){
        holdingType = "CASH"
        inputs.push(_qty,_date)
    }
    else if (isSave){
        holdingType = ticker || "SAVE"
        inputs.push(_qty, _date, _yield, _updateCash);
    }
    else {
        const cash_tax = <div key="cash_tax" className="flex gap-8">
            {_updateCash}
            <CheckButton key="applyTax" checked={tax} onChange={()=>setTax(!tax)} label="15% tax"/>
        </div>
        inputs.push(_price, _qty, cash_tax, _date)
        holdingType = ticker || "New Holding"
    }

    inputs.push(<GTextField key="notes" className="col2" placeholder="Note" value={note} onChange={(e:any)=>setNote(e.target.value)}/>);
    const options : TMenuOptions[] = [
        {value:"div",label:"Dividend",onClick:onDividend},
    ]
    if (transaction?.holding.isEquity) options.push({value:"rev",label:"Reinvest",onClick:onReinvest})
    if (isSave || isTermed) options.push({value:"redeem",label:"Redeem",onClick:onRedeem})
    if (transaction) {
        options.push({value:"dup",label:"Duplicate",onClick:onDup})
        options.push({value:"switch",label:"Change Ticker",onClick:onSwitch})
    }
    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DialogTitle><div className="ticker">{holdingType}</div></DialogTitle>
        <div className="content">{inputs}</div>
        <DialogActions>
            <Button onClick={onDelete} disabled={busy}>Delete</Button>
            <Button onClick={onSave} disabled={busy}>Save</Button>
            <MenuButton menuProps={ {options} }><MoveVert/></MenuButton>
        </DialogActions>
    </LocalizationProvider>
}

export function OpenAddHolding(){
    const {openDialog} = useDialog()
    return (trans:Transaction|null, holding:Holding|null, type?:TransactionType) => {
        openDialog({id:"addHolding", children:<AddHolding holding={holding} transaction={trans} type={type}/>})
    }
}
